<template>
  <f7-page name="ccm-examset-apply" class="page-bg-render">
    <f7-navbar>
      <div class="title">
				<span v-if="mode=='ANSWER'">답안입력</span>
        <span v-else>채점결과</span>
      </div>
			<f7-nav-right>
        <f7-link icon-ios="f7:close" icon-aurora="f7:close" icon-md="material:close" class="back"></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <f7-block-title>코드 : {{matchPaperInfo.MATCHPAPER_CODE}}<br/> 제목 : {{matchPaperInfo.MATCHPAPER_NAME}}</f7-block-title>
    <div class="list">
			<ul v-if="answers.length">
				<li v-for="(exam, i) in answers" :key="'i' + i">
					<obj-input v-if="exam.answerType == 'obj'" :seqIndex="i" :examNo="i+1" :key="forceRenderId"></obj-input>
					<sbj-input v-else-if="exam.answerType == 'sbj'" :seqIndex="i" :examNo="i+1" :key="forceRenderId"></sbj-input>
					<des-input v-else-if="exam.answerType == 'des'" :seqIndex="i" :examNo="i+1" :key="forceRenderId"></des-input>
					<null-input v-else :seqIndex="i" :examNo="i+1" :key="forceRenderId"></null-input>
				</li>
			</ul>
			<p v-else class="text-align-center padding-vertical">로딩중...</p>
		</div>

		<div class="block">
			<div class="row">
				<div class="left"></div>
				<div class="right">
					<button class="button button-fill" v-on:click="submitButtonClick" v-if="mode == 'ANSWER'">답안제출</button>
					<span class="txt-color-primary" v-else>답안 제출이 완료 되었습니다.</span>
				</div>
			</div>
		</div>
    
  </f7-page>
</template>

<script>
  import Vue from 'vue';
	import { f7 } from 'framework7-vue';
	import store from '../../../../js/store';

	import MODULE from '../../../../js/common/module';
	import AUTH from '../../../../js/common/auth.js';
	import PAGES from '../../../../js/pages';
	import API from '../../../../js/common/api.js';
	import CONST from '../../../../js/common/constant';

	import ObjInput from '../../../../components/answer/obj-input';
	import SbjInput from '../../../../components/answer/sbj-input';
	import DesInput from '../../../../components/answer/des-input';
	import NullInput from '../../../../components/answer/null-input';
  
	export default {
		components: {
			ObjInput,
			SbjInput,
			DesInput,
			NullInput
		},
    data() {
      return {
				forceRenderId: 1,
				mode: "ANSWER",
				studyKey: 0,
				studyType: "",
				matchPaperCode: "",
				matchPaperInfo: {},
				answers: []
      }
		},
		mounted() {
			const _this = this;

			_this.matchPaperCode = _this.$f7route.context.code;
			_this.studyKey = _this.$f7route.context.studyKey;
			_this.studyType = _this.$f7route.context.studyType;

			setTimeout(function() {
				if ((_this.matchPaperCode != undefined && MODULE.Util.isNotEmpty(_this.matchPaperCode) ) 
						&& (_this.studyKey != undefined && _this.studyKey == 0 ) ){
					_this.loadMatchPaperInfo();	
				} else if ( (_this.matchPaperCode != undefined && MODULE.Util.isNotEmpty(_this.matchPaperCode) )
				 && (_this.studyKey != undefined && _this.studyKey > 0) ) {
					_this.loadMatchPaperResult();
				}
			}, 300);
		},
    methods: {
			loadMatchPaperInfo() {
				var _this = this;
				var matchPaperKey = MODULE.Util.codeToKey(CONST.matchPaperCodePrefix, _this.matchPaperCode);

				let param = {
					pMatchPaperKey : matchPaperKey
				};


        API.ajaxRequest({
					url: API.getMatchPaperApplyInfoUrl(),
					data: param
				}).then(function (data) {

					var commonObj = store.getters.commonObj;
					commonObj.mode = "ANSWER";
					commonObj.matchPaperInfo = data.matchPaperInfo;
					commonObj.answers = data.answers;
					_this.mode = commonObj.mode;
					_this.matchPaperInfo = commonObj.matchPaperInfo;
					_this.answers = commonObj.answers;

				}).catch(function (code) {
					if (code == CONST.resultCode.EMPTY) {
						PAGES.back();
						MODULE.DialogBox.message("에러", "존재하지 않는 코드입니다. 코드를 확인하세요.");
						return;
					}
					
					MODULE.UITool.catchBlock(code, PAGES, AUTH);
				});
			},
			loadMatchPaperResult() {
				var _this = this;

				let param = {
					pStudyKey : _this.studyKey
				};

        API.ajaxRequest({
					url: API.getMatchPaperApplyResultUrl(),
					data: param
				}).then(function (data) {

					var commonObj = store.getters.commonObj;

					commonObj.mode = "SCORE";
					commonObj.matchPaperInfo = data.matchPaperInfo;
					commonObj.answers = data.answers;

					_this.mode = commonObj.mode;
					_this.matchPaperInfo = commonObj.matchPaperInfo;
					_this.answers = commonObj.answers;
					_this.matchPaperCode = commonObj.matchPaperInfo.MATCHPAPER_CODE;

					_this.forceRenderId++;
					
				}).catch(function (code) {
					MODULE.UITool.catchBlock(code, PAGES, AUTH);
				});  
			},
			submitButtonClick() {
				var _this = this;

				var answers = store.getters.commonObj.answers;

				var result = MODULE.Util.checkValidateAnswers(answers);
				
				var message = "";
				if (result.code != "OK") {					
					if (result.code == "EMPTY-ANSWER") {
						message = "비어있는 정답이 있습니다.<br/>조건에 맞지 않는 문항은 오답처리 됩니다.<br/>그래도 제출 할까요 ?";
					} else if (result.code == "OVERFLOW-LENGTH") {
						message = "정답이 너무 길어 잘리는 문항이 있습니다.<br/>잘린 문항은 오답처리 됩니다.<br/>그래도 제출 할까요 ?";
					}
				} else {
					message = "정답을 전송하고나면 변경할 수 없습니다.<br/>제출할까요 ?";
				}

				MODULE.DialogBox.okcancel(
					"정답 제출 확인", message,
					function() {	// on OK.
						// var wholeAnswerJson = JSON.stringify(answers);
						// MODULE.DialogBox.message(wholeAnswerJson);

						var matchPaperKey = MODULE.Util.codeToKey(CONST.matchPaperCodePrefix, _this.matchPaperCode);

						let param = {
							pStudyType: _this.studyType,
							pMatchPaperKey: matchPaperKey,
							pAnswers: answers
						};

						API.jsonRequest({
							url: API.saveMatchPaperSelfStudyUrl(),
							data: param
						}).then(function (data) {


							if(data.point != undefined){
								MODULE.DialogBox.message("알림", "획득 포인트 :" + data.point);
							}

							var commonObj = store.getters.commonObj;
							commonObj.mode = "SCORE";
							commonObj.answers = data.answers;

							_this.mode = commonObj.mode;
							_this.answers = commonObj.answers;

							_this.forceRenderId++;
						}).catch(function (code) {
							MODULE.UITool.catchBlock(code, PAGES, AUTH);
						});
					}
				);

			},
    }
  }

</script>